import { TFunction } from "react-i18next";

import { MarkNumbers } from "../../../../models/markNumbers";

export enum EditMode {
  EDITING = "editing",
  VIEW = "view",
  CONFIRM = "confirm",
  CANCEL = "cancel",
}

export interface ControlEditRow {
  [key: string]: { editMode: EditMode };
}

export interface SearchAttribute {
  attribute: string;
  values: string[];
}

interface MarkToSearch extends MarkNumbers {
  [x: string]: any;
}

export const filterMarkAndNumbers = (marks: MarkNumbers[], searchAttributes: SearchAttribute[]) => {
  return searchAttributes.reduce((filteredOrders, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredOrders.filter((mark: MarkToSearch) => {
        return values.some((value) => {
          const nestedObject = mark?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredOrders.filter((mark: MarkToSearch) => {
      return values.some((value) =>
        String(mark[attribute])?.toLowerCase().includes(value.toLowerCase())
      );
    });
  }, marks);
};

export const limitedCharactersMessage = (
  quantity: number,
  translate: TFunction<"translation", undefined>
) => `${translate("limited")} ${quantity} ${translate("characters")}`;
